module.exports = __webpack_public_path__ + "img/death_eaters_in_masks.4c72c368.jpg";